module.exports = __webpack_public_path__ + "static/media/polaroid-15.c9a911f5.png";